export const metaFields = [
    {
        name: 'Member No',
        field: 'memberno',
        check: 'confirmed',
        field2: 'membernoConfirmed',
    },
    {
        name: 'Member No Confirmed',
        field: 'membernoConfirmed',
        check: 'required',
    },
    {
        name: 'National ID No',
        field: 'memberIDNo',
        check: 'confirmed',
        field2: 'memberIDNoConfirmed',
    },
    {
        name: 'National ID No Confirm',
        field: 'memberIDNoConfirmed',
        check: 'required',
    },
    {
        name: 'Dependant',
        field: 'principalOfDependantId',
        check: 'required',
    },
    {
        name: 'Insurance',
        field: 'organizationID',
        check: 'required',
    },
];
